// extracted by mini-css-extract-plugin
export default {"scrollContainer":"Glygo","native":"nmWvR","draggable":"JcZxL","controlling":"oJirZ","clickCatcher":"uwzok","catch":"aKwkS","content":"wZ8dC"};